import * as Ajax from '../ajax/Ajax';
import "../models/user/UserResultModel";
import "../models/profile/ProfileResultModel";
/**
 * プロフィールを取得します。
 *
 * @param fn ファンクション
 */

export function GetProfile(fn) {
  Ajax.Post("ProfileApi/GetProfile", {}, Ajax.ModelResult(fn));
}
/**
 * ユーザーを更新します。
 *
 * @param userId ユーザーＩＤ
 * @param userName ユーザー名
 * @param userMailAddress メールアドレス
 * @param organizationId 組織ID
 * @param authorityId 権限ID
 * @param canSupport サポート可否
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyUser(id, name, userMailAddress, organizationId, authorityId, canSupport, updateDateTime, fn) {
  Ajax.Post("ProfileApi/ModifyUser", {
    id: id,
    name: name,
    userMailAddress: userMailAddress,
    organizationId: organizationId,
    authorityId: authorityId,
    canSupport: canSupport,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーを更新します。
 *
 * @param userId ユーザーＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ResetUserPin(id, updateDateTime, fn) {
  Ajax.Post("ProfileApi/ResetUserPin", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーパスワードを更新します。
 *
 * @param userId ユーザーＩＤ
 * @param currentPassword 現在のパスワード
 * @param password 新しいパスワード
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyUserPassword(id, currentPassword, password, updateDateTime, fn) {
  Ajax.Post("ProfileApi/ModifyUserPassword", {
    id: id,
    currentPassword: currentPassword,
    password: password,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * アバターの変換状態を取得します。
 *
 * @param id ユーザーＩＤ
 * @param avatarFileName アバターファイル名
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function GetAvatarConversionStatus(id, avatarFileName, fn) {
  Ajax.Post("ProfileApi/GetAvatarConversionStatus", {
    id: id,
    avatarFileName: avatarFileName
  }, Ajax.ModelResult(fn));
}
/**
 * サムネイルを取得します。
 *
 * @param id ユーザーＩＤ
 * @param thumbnailFileName サムネイルファイル名
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function GetThumbnail(id, thumbnailFileName, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("thumbnailFileName", thumbnailFileName);
  Ajax.Download("ProfileApi/GetThumbnail", data, fn);
}
/**
 * サムネイルをアップロードします。
 *
 * @param id ユーザーＩＤ
 * @param thumbnail サムネイル
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function UploadThumbnail(id, thumbnail, updateDateTime, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("thumbnail", thumbnail, thumbnail.name);
  data.append("updateDateTime", updateDateTime);
  Ajax.Upload("ProfileApi/UploadThumbnail", data, Ajax.ModelResult(fn));
}
/**
 * アバターを削除します。
 *
 * @param id ユーザーＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteThumbnail(id, updateDateTime, fn) {
  Ajax.Post("ProfileApi/DeleteThumbnail", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * アバターを作成します。
 *
 * @param id ユーザーＩＤ
 * @param downloadUrl ダウンロードURL
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function CreateAvatar(id, downloadUrl, updateDateTime, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("downloadUrl", downloadUrl);
  data.append("updateDateTime", updateDateTime);
  Ajax.Upload("ProfileApi/CreateAvatar", data, Ajax.ModelResult(fn));
}
/**
 * アバターをアップロードします。
 *
 * @param id ユーザーＩＤ
 * @param avator アバター
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function UploadAvatar(id, avator, updateDateTime, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("avator", avator);
  data.append("updateDateTime", updateDateTime);
  Ajax.Upload("ProfileApi/UploadAvatar", data, Ajax.ModelResult(fn));
}
/**
 * アバターを削除します。
 *
 * @param id ユーザーＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteAvatar(id, updateDateTime, fn) {
  Ajax.Post("ProfileApi/DeleteAvatar", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}